<template lang="html">

	<section class="producto-home -caramelos column-center">

		<div class="container container-title animation">
			<!-- <h1 class="big-title animation" id="titulo-split" data-splitting="chars">{{$t('header.frutosSecos')}}</h1> -->
			<h2 class="big-title animation" id="titulo-split" >{{$t('header.frutosSecos')}}</h2>
		</div>

		<div class="contenedor-ruleta">
			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.frutossecos')" :activo="select == 'frutos-secos'" @mouseover.native="select = 'frutos-secos'" class="boton" data="frutos-secos">
				<img :src="'/static/img/productos/frutos-secos/title-frutos-secos-'+$i18n.locale+'.png'" alt="Frutos secos">
			</router-link>

			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.pipas')" :activo="select == 'pipas'" @mouseover.native="select = 'pipas'" class="boton" data="pipas">
				<img :src="'/static/img/productos/frutos-secos/title-pipas-'+$i18n.locale+'.png'" alt="Pipas">
			</router-link>



			<div class="contenedor-texto">
				<espiral class="espiral-ani" delay="1000"></espiral>
				<p class="yummy waypoints">{{$t('saludablesDeliciosos')}}</p>
			</div>



			<div class="contenedor-imagen row-center">

				<img alt="imagen producto inicial" v-show="select == 'frutos-secos'" class="animated tada" :src="'/static/img/ruleta-home/frutos-secos/nueces.png'">
				<img alt="imagen producto caramelos" v-show="select == 'pipas'" class="animated tada pipas" :src="'/static/img/ruleta-home/frutos-secos/pipas.png'">


			</div>

		</div>

		<div class="contenedor-boton">
			<espiral class="espiral-ani" delay="0"></espiral>
			<router-link :to="$t('enlaces.borges')" class="btn -action waypoints" v-html="$t('todosNuestrosFrutos')"></router-link>
		</div>

		<img class="bowl-ensalada" src="/static/img/productos/frutos-secos/bowl-ensalada.png" alt="bowl-ensalada">
		<img class="cordon-avellanas" src="/static/img/productos/frutos-secos/cordon-avellanas.png" alt="cordon-avellanas">
		<img class="naranja" src="/static/img/productos/frutos-secos/nuez-entera.png" alt="naranja">



	</section>

</template>

<script lang="js">

	import espiral from '@/components/parts/icons/espiral'

	export default  {
		name: 'modulo-caramelos',
		data(){
			return{
				select : 'frutos-secos',
			}
		},
		components:{
			'espiral' : espiral
		}

	}
</script>

<style scoped lang="scss">
img.pipas{
	width:50%;
}

	.producto-home {
		background-image: linear-gradient(178deg, #ff851d 3%, #d96322 96%);
	}

	.bowl-ensalada{
		position: absolute;
		right: -100px;
		top: 100px;
        max-width: 400px;
	}
	.cordon-avellanas{
		max-width: 300px;
		position: absolute;
		left: 0px;
		top: 20px;
	}
	.naranja{
		position: absolute;
		left: 50%;
		margin-left: -20px;
		bottom: -50px;
		max-width: 200px;
	}

    .big-title{
        font-size: 160px;
    }

	.boton{
		&[data=frutos-secos]{
                right: 0;
    top: 50%;
    margin-top: -60px;
    width: 239px;

		}
		&[data="pipas"]{
			left: 0;
			top: 50%;
			margin-top: -60px;
            width: 239px;
		}

        &[data="natura"]{
			top: 50%;
			margin-top: -60px;
			right: 0;
            width: 160px;
		}
	}


	h3{
		font-size: 33px;
		text-transform: uppercase;
		color: #fff;
		font-family: 'Futura LT CondensedExtraBold';
		line-height: 1.2em;
		transform: rotate(-9deg);
		strong{
			font-family: 'Futura LT CondensedExtraBold';
			font-size: 65px;
			line-height: 1em;
		}
	}

	.btn{
		font-size: 54px;
		color: #bd2826;
		max-width: fit-content;
		height: 80px;
		line-height: 70px;

		span{
			font-size: 16px;
			color: #bd2826;
		}
	}

	.gajo-naranja{
		position: absolute;
		top: 200px;
		max-width: 200px;
		right: -30px;
	}
	.gajo-limon{
		position: absolute;
		top: -40px;
		max-width: 200px;
		right: 50%;
		margin-right: -100px;
	}
	.acido-verde-amarillo{
		position: absolute;
		left: 100px;
		top: -120px;
		max-width: 300px;
	}

	.azul-individual{
		position: absolute;
		left: 100px;
		bottom: -20px;
		max-width: 230px;
	}

	.lima{
		position: absolute;
		bottom: -150px;
		right: -150px;
		max-width: 400px;
		filter: blur(2px);
	}

	.limon{
		position: absolute;
		bottom: 350px;
		left: 50px;
		max-width: 250px;
		filter: blur(1px);
	}

	.contenedor-texto{
		position: absolute;
		left: 0;
		bottom: 0;
		width: 200px;
		height: 300px;
		padding-top: 200px;
		transform: rotate(10deg);

		.contenedor-espiral{
			position: absolute;
			left: 60px;
			top: 20px;
			transform: scale(.8) rotate(20deg);
		}

		p{
			font-size: 36px;
			color: white;
			display: inline-block;
			line-height: 30px;
			margin-top: 30px;
			animation-delay: 2s;
		}
	}


	@media screen and (max-width: 1500px){
		.bowl-ensalada{
			max-width: 200px;
			right: -50px;
		}
	}

	@media screen and (max-width: 1220px){

		.cordon-avellanas{
			max-width: 200px;
		}

	}

	@media screen and (max-width: 900px){
		.contenedor-texto{
			display: none;
		}
		.big-title{
			font-size: 90px;
		}

		.naranja{
			max-width: 200px;
			bottom: -50px;
			left: 20px;
		}
		.cordon-avellanas{
			display: none;
		}
	}


	@media screen and (max-width: 560px){
		.big-title{
			font-size: 50px;
		}

		.naranja{
			bottom: -120px;
		}
	}


</style>



// WEBPACK FOOTER //
// src/components/views/home/modulo-frutos-secos.vue